export default __webpack_public_path__ + "static/media/background_login.50b37b3c.png";